import { Component, Input } from '@angular/core';
import { Question } from '@core/models/question.model';

@Component({
  selector: 'app-disable-semantic-ability',
  templateUrl: './disable-semantic-ability.component.html',
  styleUrls: ['./disable-semantic-ability.component.css'],
})
export class DisableSemanticAbilityComponent {
  @Input() question!: Question;
}
